import {
	auth,
	firebase,
	storage,
	usersCollection,
	verificationCollection,
} from '../../config/firebase';
import router from '@/router';

import { RepositoryFactory } from '../../repository/RepositoryFactory';
let SubscriptionRepository = RepositoryFactory.get('subscription');

let authUser = JSON.parse(localStorage.getItem('authUser'));
let state = {
	authUser: authUser,
	reload: true,
	loading: false,
	isVerificiationPending: true,
	notification: { message: '', type: '' },
};
let getters = {
	authUser: state => state.authUser,
	authLoading: state => state.loading,
	isVerificiationPending: state => state.isVerificiationPending,
	reload: state => state.reload,
	authNotification: state => state.notification,
};
let actions = {
	async sendVerification({ commit }, payload) {
		let verificationRef = storage.ref('verification_docs');
		let uniqueId = payload['user_id'];
		delete payload['user_id'];
		let parts = payload.file.name.split('.');
		let ext = parts[parts.length - 1];
		let filename = uniqueId + '.' + ext;
		await verificationRef.child(filename).put(payload['file']);
		payload['file'] = await verificationRef
			.child(filename)
			.getDownloadURL();
		await verificationCollection.doc(uniqueId).set({ ...payload });
	},

	async isVerificationRequested({ commit }, payload) {
		verificationCollection.doc(payload).onSnapshot(verificationSnap => {
			commit(
				'setVerificationStatus',
				verificationSnap.data() ? true : false
			);
		});
	},
	async getAuthUser({ commit }, uid) {
		usersCollection.doc(uid).onSnapshot(async snapshot => {
			let userData = snapshot.data();
			let isActive = false;
			try {
				let { data } = await SubscriptionRepository.checkSubscription(
					userData.subscription_id
				);
				isActive = data.status == 'active' ? true : false;
				commit('setAuthData', { id: uid, ...userData, isActive });
			} catch (err) {
				console.log(err.message);
			}
		});
	},
	async validateEmail({ commit }, payload) {
		let onSuccess = payload.onSuccess;
		let email = payload.email;
		let userDoc = await firebase
			.firestore()
			.collection('users')
			.where('email', '==', email)
			.get();
		onSuccess(userDoc.size == 0);
	},
	async validateUsername({ commit }, payload) {
		let onSuccess = payload.onSuccess;
		let username = payload.username;
		let userDoc = await firebase
			.firestore()
			.collection('users')
			.where('username', '==', username)
			.get();
		onSuccess(userDoc.size == 0);
	},
	async registers({ commit }, payload) {
		commit('setAuthLoading', true);
		payload['isCompleted'] = false;
		payload['isBlock'] = false;
		payload['joined_datetime'] = firebase.firestore.Timestamp.fromDate(
			new Date()
		);
		payload['email_notifications'] = true;
		payload['user_type'] = 'user';
		payload['last_login'] = null;
		payload['connects'] = [];

		let usernameSnap = await usersCollection
			.where('username', '==', payload['username'])
			.get();
		if (usernameSnap.size == 0) {
			await auth
				.createUserWithEmailAndPassword(payload.email, payload.password)
				.then(async data => {
					let uid = data.user.uid;
					delete payload.password;
					data.user.sendEmailVerification();
					await usersCollection.doc(uid).set({ ...payload });
					commit('setAuthLoading', false);
					router.push('/login?payment_success');
				})
				.catch(err => {
					commit('setAuthNotification', {
						message: err.message,
						type: 'error',
					});
				});
		} else {
			commit('setAuthNotification', {
				message:
					'Username already exist. Choose unique username to proceed.',
				type: 'error',
			});
		}
		commit('setAuthLoading', false);
	},
	async login({ commit, dispatch }, payload) {
		commit('setAuthLoading', true);
		let snaps = await usersCollection
			.where('email', '==', payload.email)
			.get();
		if (snaps.docs.length > 0) {
			await auth
				.signInWithEmailAndPassword(payload.email, payload.password)
				.then(async data => {
					let uid = data.user.uid;
					let emailVerified = data.user.emailVerified;
					if (emailVerified) {
						let userSnap = await usersCollection.doc(uid).get();
						let userData = userSnap.data();
						if (userData.isBlock) {
							commit('setAuthNotification', {
								message: 'Your account is blocked by admin.',
								type: 'error',
							});
						} else {
							userData['isFirstLogin'] =
								userData.last_login == null;
							userData['last_login'] =
								firebase.firestore.Timestamp.fromDate(
									new Date()
								);

							await usersCollection
								.doc(uid)
								.update({ last_login: userData['last_login'] });
							let isActive = false;
							try {
								let { data } =
									await SubscriptionRepository.checkSubscription(
										userData.subscription_id
									);

								isActive =
									data.status == 'active' ? true : false;

								commit('setAuthData', {
									id: uid,
									...userData,
									isActive,
								});
							} catch (err) {
								console.log(err.response);
							}
							commit('setAuthLoading', false);
							router.push('/dashboard');
						}
					} else {
						await auth.signOut().then(() => {
							commit('setAuthNotification', {
								message: 'Verify your account to login.',
								type: 'error',
							});
						});
					}
				})
				.catch(err => {
					commit('setAuthNotification', {
						message: err.message,
						type: 'error',
					});
				});
		} else {
			commit('setAuthNotification', {
				message: "Email didn't matched with any account.",
				type: 'error',
			});
		}
		commit('setAuthLoading', false);
	},
	async logout({ commit }, payload) {
		await auth.signOut().then(() => {
			commit('setAuthData', '');
			router.push('/login');
		});
	},
	async forgetPassword({ commit }, payload) {
		commit('setAuthLoading', true);
		await auth
			.sendPasswordResetEmail(payload)
			.then(() => {
				commit('setAuthNotification', {
					message: 'Reset link has been sent to your Email',
					type: 'success',
				});
			})
			.catch(err => {
				commit('setAuthNotification', {
					message: err.message,
					type: 'error',
				});
			});
		commit('setAuthLoading', false);
	},
	async updateProfile({ commit }, payload) {
		commit('setAuthLoading', true);
		delete payload['email'];
		let { id } = payload;

		delete payload.id;
		if (
			payload['profile_image'] &&
			typeof payload['profile_image'] != 'string'
		) {
			let profile_image = payload['profile_image'];
			let fileParts = profile_image.name.split('.');
			let filename = `${id}.${fileParts[fileParts.length - 1]}`;
			await storage
				.ref(`/user/profile_pic/${filename}`)
				.put(profile_image);
			payload['profile_image'] = await storage
				.ref(`user/profile_pic`)
				.child(filename)
				.getDownloadURL();
		}
		payload['isCompleted'] = true;
		await usersCollection.doc(id).update({ ...payload });
		let user = await usersCollection.doc(id).get();
		commit('setAuthLoading', false);
		commit('setAuthData', { ...user.data(), id });
		if (router.currentRoute.fullPath != '/profile') {
			router.push('/profile');
		}
	},
};
let mutations = {
	setVerificationStatus(state, payload) {
		state.isVerificiationPending = payload;
	},
	setAuthData(state, payload) {
		if (payload == '') {
			localStorage.removeItem('authUser');
		} else {
			let authUser = JSON.parse(localStorage.getItem('authUser'));
			if (authUser) {
				payload['isFirstLogin'] = authUser.isFirstLogin
					? authUser.isFirstLogin
					: true;
			}
			localStorage.setItem('authUser', JSON.stringify(payload));
		}
		state.authUser = payload;
		state.reload = false;
	},
	setAuthLoading(state, payload) {
		state.loading = payload;
	},
	setAuthNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
